import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Title: {
    id: 'modules_title',
    defaultMessage: 'Programme structure',
  },
  TitleLabel: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  Description: {
    id: 'label_description',
    defaultMessage: 'Description',
  },
  Modules: {
    id: 'label_modules',
    defaultMessage: 'Modules',
  },
  ModulesHelp: {
    id: 'help_module_groups',
    defaultMessage:
      'Structures the modules aggregated from the page properties into module types.',
  },
  Degree: {
    id: 'label_degree',
    defaultMessage: 'Degree',
  },
  ShowTeaserImage: {
    id: 'label_show_teaser_image',
    defaultMessage: 'Show teaser image',
  },
  ShowUniversity: {
    id: 'label_show_school',
    defaultMessage: 'Show school',
  },
  ModuleType: {
    id: 'label_module_type',
    defaultMessage: 'Module type',
  },
  AddModuleType: {
    id: 'label_add_module_type',
    defaultMessage: 'Add module type',
  },
  ShowModuleType: {
    id: 'label_show_module_type',
    defaultMessage: 'Show module type',
  },
  MandatoryProgram: {
    id: 'modules_mandatory_program',
    defaultMessage: 'Mandatory Program',
  },
  ElectiveProgram: {
    id: 'modules_elective_program',
    defaultMessage: 'Elective Program',
  },
  ElectiveMandatoryProgram: {
    id: 'modules_elective_mandatory_program',
    defaultMessage: 'Elective Mandatory Program',
  },
});
